"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectSimple = function SelectSimple(props) {
  var options = props.options,
      onChange = props.onChange,
      value = props.value,
      placeholder = props.placeholder,
      disabled = props.disabled;

  var convertOptions = function convertOptions(opt) {
    var optionTransformed = [];
    opt.forEach(function (element) {
      optionTransformed.push({
        value: element.id,
        label: element.nombre
      });
    });
    return optionTransformed;
  };

  var getOptionSelected = function getOptionSelected(valueSelected) {
    var valueEncounter = convertOptions(options).filter(function (e) {
      return e.value === valueSelected;
    });

    if (valueEncounter.length === 0) {
      return null;
    }

    return valueEncounter[0];
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '400px'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
    value: getOptionSelected(value),
    defaultValue: getOptionSelected(value),
    isDisabled: disabled,
    placeholder: placeholder,
    isSearchable: false,
    onChange: onChange,
    options: convertOptions(options)
  }));
};

SelectSimple.propTypes = {
  options: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  onChange: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  placeholder: _propTypes.default.string
};
SelectSimple.defaultProps = {
  value: '',
  placeholder: '',
  disabled: false
};
var _default = SelectSimple;
exports.default = _default;